import React from 'react'
import cx from 'classnames'
import { Icon } from '@manychat/manyui'

import cm from './StepIndicator.module.css'

interface StepProps {
  number: number
  isCompleted: boolean
  isCurrent: boolean
  isBlocked?: boolean
  className?: string
}

export const StepIndicator = ({
  number,
  isCompleted,
  isCurrent,
  isBlocked,
  className,
}: StepProps) => (
  <div
    className={cx(className, cm.stepIndicator, {
      [cm.stepIndicator_current]: isCurrent,
    })}
    aria-hidden
  >
    {isCompleted && !isBlocked && <Icon.DoubleTick size={16} />}

    {!isCompleted && !isBlocked && number}

    {isBlocked && <Icon.Protect size={16} />}
  </div>
)
